import 'core-js/stable';
import Vue from 'vue';

import {
	CRow,
	CCol,
	CBadge,
	CButton,
	CButtonClose,
	CButtonGroup,
	CCard,
	CCardBody,
	CContainer,
	CDataTable,
	CDropdown,
	CDropdownDivider,
	CDropdownHeader,
	CDropdownItem,
	CFooter,
	CForm,
	CHeader,
	CHeaderBrand,
	CHeaderNav,
	CHeaderNavItem,
	CHeaderNavLink,
	CIcon,
	CInput,
	CInputCheckbox,
	CInputRadio,
	CLink,
	CListGroup,
	CListGroupItem,
	CModal,
	CPagination,
	CRenderFunction,
	CSidebar,
	CSidebarBrand,
	CSidebarClose,
	CSidebarNav,
	CSidebarNavDropdown,
	CSidebarNavDivider,
	CSidebarNavItem,
	CSidebarNavTitle,
	CSpinner,
	CSwitch,
	CSubheader,
	CTab,
	CTabs,
	CTextarea,
	CToast,
	CToaster,
	CToggler,
	CWrapper,
	CCollapse,
} from '@coreui/vue';

// Register the component globally
Vue.component('CRow', CRow);
Vue.component('CCol', CCol);
Vue.component('CBadge', CBadge);
Vue.component('CButton', CButton);
Vue.component('CButtonClose', CButtonClose);
Vue.component('CButtonGroup', CButtonGroup);
Vue.component('CCard', CCard);
Vue.component('CCardBody', CCardBody);
Vue.component('CContainer', CContainer);
Vue.component('CDataTable', CDataTable);
Vue.component('CDropdown', CDropdown);
Vue.component('CDropdownDivider', CDropdownDivider);
Vue.component('CDropdownHeader', CDropdownHeader);
Vue.component('CDropdownItem', CDropdownItem);
Vue.component('CFooter', CFooter);
Vue.component('CForm', CForm);
Vue.component('CHeader', CHeader);
Vue.component('CHeaderBrand', CHeaderBrand);
Vue.component('CHeaderNav', CHeaderNav);
Vue.component('CHeaderNavItem', CHeaderNavItem);
Vue.component('CHeaderNavLink', CHeaderNavLink);
Vue.component('CIcon', CIcon);
Vue.component('CInput', CInput);
Vue.component('CInputCheckbox', CInputCheckbox);
Vue.component('CInputRadio', CInputRadio);
Vue.component('CLink', CLink);
Vue.component('CListGroup', CListGroup);
Vue.component('CListGroupItem', CListGroupItem);
Vue.component('CModal', CModal);
Vue.component('CPagination', CPagination);
Vue.component('CRenderFunction', CRenderFunction);
Vue.component('CSidebar', CSidebar);
Vue.component('CSidebarBrand', CSidebarBrand);
Vue.component('CSidebarClose', CSidebarClose);
Vue.component('CSidebarNav', CSidebarNav);
Vue.component('CSidebarNavDropdown', CSidebarNavDropdown);
Vue.component('CSidebarNavDivider', CSidebarNavDivider);
Vue.component('CSidebarNavItem', CSidebarNavItem);
Vue.component('CSidebarNavTitle', CSidebarNavTitle);
Vue.component('CSpinner', CSpinner);
Vue.component('CSwitch', CSwitch);
Vue.component('CSubheader', CSubheader);
Vue.component('CTab', CTab);
Vue.component('CTabs', CTabs);
Vue.component('CTextarea', CTextarea);
Vue.component('CToast', CToast);
Vue.component('CToaster', CToaster);
Vue.component('CToggler', CToggler);
Vue.component('CWrapper', CWrapper);
Vue.component('CCollapse', CCollapse);